import type { FC, ReactNode } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { Text } from 'src/modules/shared/components/atoms/text';

interface StatusDropdownGroupHeaderProps {
  label: string;
  icon: ReactNode;
  itemCount: number;
  isCollapsed: boolean;
}

/**
 * Non-terminal dropdown row used to expand or collapse grouped AI statuses.
 */
export const StatusDropdownGroupHeader: FC<StatusDropdownGroupHeaderProps> = ({
  label,
  icon,
  itemCount,
  isCollapsed,
}) => {
  return (
    <div className="flex w-full items-center justify-between gap-3 py-1">
      <div className="flex items-center gap-2">
        {icon}
        <Text
          size="tiny"
          weight="medium"
          color="secondary"
          className="uppercase tracking-[0.08em]"
        >
          {label}
        </Text>
      </div>
      <div className="flex items-center gap-2">
        <Text size="tiny" color="secondary" className="opacity-70">
          {itemCount}
        </Text>
        {isCollapsed ? (
          <ChevronDownIcon className="h-4 w-4 text-secondary-500" />
        ) : (
          <ChevronUpIcon className="h-4 w-4 text-secondary-500" />
        )}
      </div>
    </div>
  );
};
